.ao{overflow:hidden;}